<template>
  <main>
    <div class="whiteBackground p-3" style="height: 400px;">
      <b-container>
        <section id="header">
          <div class="mt-2 mb-4">
            <p class="myStudiesHeader text-center">
              Toll Free Numbers for Pfizer Application Support
            </p>
          </div>
        </section>
        <hr class="solid my-4" />

        <section id="countryPhoneNumbers" class="mb-4" v-if="!loading">
          <multiselect
            v-model="selected"
            :allow-empty="true"
            :disabled="loading"
            :options="filteredOptions"
            :searchable="true"
            :internal-search="false"
            @search-change="customSearch"
            class="multiselect-dropdown"
            label="country"
            placeholder="Select a country"
            track-by="country"
          ></multiselect>
          <p class="cardContent text-center mt-3">
            Note: If your country is not listed, call the Pfizer Generic Number 0014452021277 (USA
            number, International Dialing Rates Apply)
          </p>
          <b-card class="cardStyle text-center" v-if="selected">
            <strong>Phone</strong>
            <p class="cardContent">
              <span v-for="(phone, index) in formattedPhoneNumbers" :key="index">
                <a :href="'tel:' + phone">{{ phone }}</a>
                <span v-if="index < formattedPhoneNumbers.length - 1">, </span>
              </span>
            </p>
            <div v-if="selected.notes">
              <strong>Note</strong>
              <p class="cardContent">{{ selected.notes }}</p>
            </div>
          </b-card>
        </section>
        <div class="text-center">
          <b-spinner v-if="loading" type="grow"></b-spinner>
        </div>
      </b-container>
    </div>
  </main>
</template>

<script>
  export default {
    name: 'ApplicationSupportNumbers',
    data() {
      return {
        selected: null,
        loading: false,
        countryPhoneNumbers: [],
        filteredOptions: [],
        countryMapping: {
          Albania: 'ALBANIA',
          Argentina: 'ARGENTINA',
          Armenia: 'ARMENIA',
          'Australia (Optus)': 'AUSTRALIA',
          Austria: 'AUSTRIA',
          Bangladesh: null,
          Belarus: 'BELARUS',
          Belgium: 'BELGIUM',
          Bosnia: 'BOSNIA AND HERZEGOVINA',
          Brazil: 'BRAZIL',
          Bulgaria: 'BULGARIA',
          Canada: 'CANADA',
          Chile: 'CHILE',
          China: 'CHINA',
          Colombia: 'COLOMBIA',
          'Costa Rica': 'COSTA RICA',
          Croatia: 'CROATIA',
          Cuba: null,
          Cyprus: 'CYPRUS',
          'Czech Republic': 'CZECH REPUBLIC',
          Denmark: 'DENMARK',
          Ecuador: 'ECUADOR',
          Estonia: 'ESTONIA',
          Finland: 'FINLAND',
          France: 'FRANCE',
          Gambia: null,
          Georgia: 'GEORGIA',
          Germany: 'GERMANY',
          Ghana: 'GHANA',
          Greece: 'GREECE',
          Guatemala: 'GUATEMALA',
          'Hong Kong': 'HONG KONG',
          Hungary: 'HUNGARY',
          India: 'INDIA',
          Indonesia: 'INDONESIA',
          Ireland: 'IRELAND',
          Israel: 'ISRAEL',
          Italy: 'ITALY',
          Japan: 'JAPAN',
          Jordan: 'JORDAN',
          Kazakhstan: 'KAZAKHSTAN',
          Kenya: 'KENYA',
          'South Korea': 'SOUTH KOREA',
          Latvia: 'LATVIA',
          Lebanon: 'LEBANON',
          Liechtenstein: null,
          Lithuania: 'LITHUANIA',
          Luxembourg: 'LUXEMBOURG',
          Malawi: 'MALAWI',
          'Macedonia, F.Y.R': 'MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF',
          Malaysia: 'MALAYSIA',
          Mexico: 'MEXICO',
          Moldova: 'MOLDOVA, REPUBLIC OF',
          Monaco: 'MONACO',
          Mozambique: 'MOZAMBIQUE',
          Netherlands: 'NETHERLANDS',
          'New Zealand': 'NEW ZEALAND',
          Nigeria: 'NIGERIA',
          Norway: 'NORWAY',
          Oman: 'OMAN',
          Panama: 'PANAMA',
          Paraguay: 'PARAGUAY',
          Peru: 'PERU',
          Philippines: 'PHILIPPINES',
          Poland: 'POLAND',
          Portugal: 'PORTUGAL',
          'Puerto Rico': 'PUERTO RICO',
          Qatar: 'QATAR',
          'Reunion Island': null,
          Romania: 'ROMANIA',
          Russia: 'RUSSIAN FEDERATION',
          'Saudi Arabia': 'SAUDI ARABIA',
          Serbia: 'SERBIA',
          Singapore: 'SINGAPORE',
          Slovakia: 'SLOVAKIA',
          Slovenia: 'SLOVENIA',
          'South Africa': 'SOUTH AFRICA',
          Spain: 'SPAIN',
          Sweden: 'SWEDEN',
          Switzerland: 'SWITZERLAND',
          Taiwan: 'TAIWAN',
          Tanzania: 'TANZANIA, UNITED REPUBLIC OF',
          Thailand: 'THAILAND',
          Tunisia: 'TUNISIA',
          Turkey: 'TURKEY',
          'United Arab Emirates': 'UNITED ARAB EMIRATES',
          Uganda: 'UGANDA',
          Ukraine: 'UKRAINE',
          'United Kingdom': 'UNITED KINGDOM',
          Uruguay: null,
          'United States': 'UNITED STATES',
          Venezuela: null,
          Vietnam: null,
        },
      };
    },
    async created() {
      await this.getSupportPhoneNumbers();
      this.setSelectedCountry();
    },
    computed: {
      formattedPhoneNumbers() {
        return this.selected.phone_number.split(',').map(phone => phone.trim());
      },
    },
    methods: {
      customSearch(input) {
        if (input) {
          const filteredOptions = this.countryPhoneNumbers.filter(option => {
            const startsWithInput = option.country.toLowerCase().startsWith(input.toLowerCase());
            return startsWithInput;
          });
          this.filteredOptions = filteredOptions;
        } else {
          this.filteredOptions = this.countryPhoneNumbers;
        }
      },
      async getSupportPhoneNumbers() {
        this.loading = true;
        try {
          const response = await axios.get('/get-support-phone-numbers');
          this.countryPhoneNumbers = response.data;
          this.filteredOptions = this.countryPhoneNumbers;
        } catch (error) {
          this.$bvToast.toast('Server is not responding, please try again later', {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true,
            variant: 'danger',
          });
        } finally {
          this.loading = false;
        }
      },
      setSelectedCountry() {
        let countryNameValue = localStorage.getItem('countryName');
        if (!countryNameValue) {
          return;
        }
        let countryName = Object.keys(this.countryMapping).find(
          key =>
            this.countryMapping[key] &&
            this.countryMapping[key].toLowerCase() === countryNameValue.toLowerCase(),
        );
        let countryOption;
        if (countryName && window.Laravel.user_email) {
          countryOption = this.filteredOptions.find(option => {
            return option.country.toLowerCase() === countryName.toLowerCase();
          });
          if (countryOption) {
            this.selected = countryOption;
          }
        }
      },
    },
  };
</script>

<style scoped>
  .cardStyle {
    background: #fffbfe;
    border-radius: 8px;
    margin-top: 2rem;
  }
  .cardTitle {
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    letter-spacing: 0.25px;
    color: #00004e;
  }
  .cardContent {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.5px;
  }

  .multiselect-dropdown {
    z-index: 1000; /* or any high number */
  }
</style>
